"use client";

import React from "react";
import { Star } from "lucide-react";
import { Carousel, CarouselContent, CarouselItem, CarouselNext, CarouselPrevious } from "@/components/ui/carousel";
const testimonials = [{
  id: 1,
  quote: "Finding a home with Urban Living Rentals was the best decision we made. The architectural details and the seamless tour scheduling made the process effortless.",
  name: "Julianne Vance",
  rating: 5
}, {
  id: 2,
  quote: "The attention to detail in these apartments is breathtaking. It feels more like a curated art gallery than a rental. Truly a sophisticated living experience.",
  name: "Marcus Sterling",
  rating: 5
}, {
  id: 3,
  quote: "Professional, responsive, and high-end. The Royal Blue accents throughout the property and the digital management system are exactly what I was looking for.",
  name: "Elena Rodriguez",
  rating: 5
}];
export default function ResidentExperiences() {
  return <section data-section-id="234033" id="resident-experiences" className="w-full py-24 md:py-32 bg-accent text-foreground overflow-hidden">
      <div className="container mx-auto px-4 md:px-6">
        <div className="flex flex-col items-center text-center mb-16">
          <h2 className="font-default text-3xl md:text-4xl lg:text-5xl font-bold text-foreground tracking-tighter mb-4">
            Resident Experiences
          </h2>
          <div className="w-24 h-1 bg-primary rounded-md opacity-100"></div>
        </div>

        <div className="max-w-5xl mx-auto relative px-8 md:px-16">
          <Carousel opts={{
          loop: true,
          align: "center"
        }} className="w-full">
            <CarouselContent>
              {testimonials.map((testimonial, i) => <CarouselItem key={testimonial.id} data-index={i}>
                  <div className="flex flex-col items-center text-center px-4 md:px-12 py-8">
                    <div className="flex gap-1 mb-8">
                      {Array.from({
                    length: testimonial.rating
                  }).map((_, index) => <Star key={index} className="size-6 md:size-8 fill-primary text-primary" aria-hidden="true" />)}
                    </div>
                    
                    <blockquote className="mb-10">
                      <p className="font-serif italic text-2xl md:text-3xl lg:text-4xl leading-relaxed text-foreground/90">
                        "{testimonial.quote}"
                      </p>
                    </blockquote>
                    
                    <div className="mt-auto">
                      <p className="font-default font-bold text-lg md:text-xl text-foreground uppercase tracking-widest">
                        — {testimonial.name}
                      </p>
                    </div>
                  </div>
                </CarouselItem>)}
            </CarouselContent>
            
            <CarouselPrevious className="bg-primary text-primary-foreground hover:bg-primary/90 border-none size-12 md:size-14 shadow-lg -left-2 md:-left-6" />
            <CarouselNext className="bg-primary text-primary-foreground hover:bg-primary/90 border-none size-12 md:size-14 shadow-lg -right-2 md:-right-6" />
          </Carousel>
        </div>
      </div>
    </section>;
}